module.exports = __webpack_public_path__ + "static/media/tutorial.80111033.png";